import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import parse from 'html-react-parser';

class AboutV5 extends Component {

    render() {

        let publicUrl = process.env.PUBLIC_URL+'/'
        let imagealt = 'image'

    return <section className="about-five  go-top">
			  <div className="container">
			    <div className="row">
			      <div className="col-lg-6">
			        <div className="about-five__content">
			          <div className="block-title-two text-left">
			            <h3>Ultimate Core Features <br /> For Your Web App</h3>
			          </div>{/* /.block-title-two */}
			          {/*<p>Lorem ipsum dolor sit amet consectetur adipisicing elit sed do eiusmod tem <br /> or incididunt ut labore et dolore magna aliqua. </p>*/}
			          <ul className="about-five__list list-unstyled">
			            <li>
			              <i className="far fa-check" />
							<strong> Real-Time Conversations – </strong> Engage visitors instantly.
			            </li>
			            <li>
			              <i className="far fa-check" />
							<strong> Context-Aware Responses – </strong> Understands customer intent naturally.
						</li>
			            <li>
			              <i className="far fa-check" />
							<strong> Smart Lead Capture – </strong> Automatically collects name, contact information, and preferences.
			            </li>
			            <li>
			              <i className="far fa-check" />
							<strong> Human-Like Calls – </strong> Natural speech powered by advanced AI.
			            </li>
			          </ul>{/* /.about-five__list list-unstyled */}
			          <Link to="/service" className="thm-btn about-five__btn">Get Started <i className="fa fa-angle-double-right" /></Link>{/* /.thm-btn about-five__btn */}
			        </div>{/* /.about-five__content */}
			      </div>{/* /.col-lg-6 */}
			      <div className="col-lg-6">
			        <div className="about-five__image">
			          <img src={publicUrl+"assets/images/resources/app-image1.png"} alt={ imagealt } />
			        </div>{/* /.about-five__image */}
			      </div>{/* /.col-lg-6 */}
			    </div>{/* /.row */}
			  </div>{/* /.container */}
			</section>

        }
}

export default AboutV5